import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SxSecurityService } from '../infrastructure/services/sxSecurity.service';
import { SxContextService } from '../infrastructure/services/sxContext.service';
import { ItemGeneralListado } from '../helpers/components/itemClasses/itemListadoGeneral.class';

@Component({
  templateUrl: './private.section.layout.html'
})
export class PrivateSectionLayoutComponent implements OnInit {
  sistema: any;
  sistemas: Observable<ItemGeneralListado[]>;
  currentContext;

  constructor(
    public router: Router,
    protected route: ActivatedRoute,
    public sxContextService: SxContextService,
    public securityService: SxSecurityService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        /**
         * Nos fijamos si viene un codigo de Sistema por ruta
         */
        if (
          this.router.routerState.root.firstChild &&
          this.router.routerState.root.firstChild.firstChild
        ) {
          this.router.routerState.root.firstChild.firstChild.params.subscribe(
            params => {
              const codSistema = params['codsistema'];
              if (codSistema) {
                this.sxContextService.setContexto(codSistema, true);
              }
            }
          );
        }
      }
    });
  }

  ngOnInit() {
    document.getElementById('container-principal').classList.add('container');
    this.currentContext = this.sxContextService.currentContext;

    this.sistema = this.sxContextService.getContexto(true);

    this.sxContextService.currentContext.subscribe(_ => {
      this.sistema = this.sxContextService.getContexto(true);
    });
  }

  navegar(ruta: string) {
    if (this.sxContextService.getContexto(true)) {
      this.router.navigate([`/soc/backoffices/${this.sistema}/${ruta}`]);
    }
  }

  seleccionarSistema(sistema) {
    this.sxContextService.setContexto(sistema.id, true);
    this.sistema = sistema.id;
    this.router.navigate([`/soc/backoffices/${sistema.id}`]);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/private.section.layout.ts